import React, { useRef, useEffect, useState } from "react"
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import { useHistory } from 'react-router-dom';
import { ApiService } from '../../containers/Services/apiservice';
let apiServices = new ApiService();
function NomineeVarify() {
  let history = useHistory();
  const [canId, setCanId] = useState('')
  const [spinnerLoading, setSpinnerLoading] = useState()
  useEffect(() => {
   const dataString = {
    }
    apiServices.getUserData(dataString).then(result => {
      if (result.data.status == 'success') {
        setCanId(result.data.data.gs_can_id)
      }
      else if (result.data.status == "error" && result.data.message == "Session expired") {
        localStorage.removeItem('AUTH_TOKEN');
        // alert(result.data.message)
        setSpinnerLoading(false)
        history.push("/login")
      }
      else {
        alert(result.data.message)
        setSpinnerLoading(false)
        return false
      }
    })
  }, []);
  const checkconcentstatus = () => {
    history.push("/investorconcent")
  }
  return (
    <>
      <Header />
      <section className='bg-gray-light'>
        <div className='container-fluid' style={{ marginTop: "-90px" }}>
          <div className='row '>
            <div className='col-lg-12'>
              <div className="golstarbox text-center">
                <div className='goalsetting-block mg-b-15'>
                  <h6>Confirm Your nominee details</h6>
                  <p>Your CAN number is: <b>{canId}</b>. You will need this for confirming the nominee details. </p>
                  <a href="https://mfuonline.com/CNOMV" type="submit" className="mt-10 buttonab-line" target="new" onClick={checkconcentstatus}>Next<i className="fa fa-long-arrow-right mg-l-10" aria-hidden="true" ></i></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}
export default NomineeVarify